// Centralized validation for Project Page edit flow

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split(".");
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    const key = parts[i];
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[key];
  }
  return cur;
}

export function validateProjectPageEditForm(current) {
  const errs = {};
  if (!current || typeof current !== "object") return errs;

  // Field label mapping
  const fieldLabels = {
    "info.type": "Page Type",
    "info.projectId": "Project",
  };

  // Required fields
  const required = ["info.type", "info.projectId"];
  required.forEach((path) => {
    const v = getByPath(current, path);
    if (v === undefined || String(v).trim() === "") {
      errs[path] = `${fieldLabels[path]}: This field is required`;
    }
  });

  return errs;
}
